<template>
    <div class="tab-view" :class="{
        'one-tab': tabs.length < 2
    }">
        <div class="tab-header">
            <div v-for="(tab, index) in tabs" :key="index" class="tab-item" :class="{
                'active': index===activeTab
            }" @click="switchTab(index)">
                <template v-if="tab==='Covid-19 Questionnaire'">
                    <span class="text-primary" style="font-weight: bold;">
                        {{ tab }}
                    </span>
                </template>
                <template v-else>
                    {{ tab }}
                </template>
            </div>
        </div>
        <div class="tab-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'TabView',
    'props': {
        'tabs': {
            'type': Array,
            default () {
                return [
                    'Tab 1',
                    'tab 2'
                ];
            }
        },
        'activeTab': {
            'type': Number,
            'default': 0
        }
    },
    data () {
        return {};
    },
    'methods': {
        switchTab (index) {
            if (this.tabs.length > index) {
                this.$emit('update:activeTab', index);
            }
        }
    }
};
</script>

<style>
.tab-view{

}

.tab-view .tab-header{
    display: flex;
}

.tab-view.one-tab .tab-header {
    display: none !important;
}

.tab-view .tab-header .tab-item{
    user-select: none;
    padding: .5rem 1rem;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    border: 1px solid #ccc;
    cursor: pointer;
    margin-bottom: -1px;
    background-color: #fff;
}

.tab-view .tab-header .tab-item:not(.active):hover{
    background-color: #eee;
}

.tab-view .tab-header .tab-item +.tab-item{
    border-left: none;
}

.tab-view .tab-header .tab-item.active{
    cursor: auto;
    border-bottom: none;
    font-weight: 700;
}

.tab-view:not(.one-tab) .tab-body{
    border: 1px solid #ccc;
    padding: 1.25rem;
}
</style>
